const Nunjucks = require('nunjucks');
const SpacelessExtension = require('nunjucks-tag-spaceless');
const NumberFormat = require('./nunjucks-filter-number-format');
const Linkfy = require('./nunjucks-filter-linkfy');

const env = new Nunjucks.Environment();

env.addExtension('spaceless', new SpacelessExtension());

env.addFilter('number_format', NumberFormat);
env.addFilter('linkfy', Linkfy);


module.exports = env;



//////////////////
// WEBPACK FOOTER
// ./lib/view.js
// module id = 1
// module chunks = 0